import { render } from "./Index.vue?vue&type=template&id=a75db46c&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=a75db46c&scoped=true&lang=css"

import exportComponent from "/root/apps/cantic/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a75db46c"]])

export default __exports__